

















import { Component, Vue } from "vue-property-decorator";
import LandingLayout from "@/components/layouts/LandingLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import { namespace } from "vuex-class";

const Auth = namespace("Auth");
const AppModule = namespace("App");

@Component
export default class App extends Vue {
  @AppModule.State
  private loading!: boolean;

  @AppModule.Action
  private onResize!: () => void;

  mounted(): void {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  }

  beforeDestroy(): void {
    window.removeEventListener('resize', this.onResize);
  }

  get layout() {
    const routeLayout = this.$route.meta.layout;
    return routeLayout === 'landing' ? LandingLayout : MainLayout;
  }
}
